import React, { useState } from 'react';
import axios from '../axios';
import { useNavigate } from 'react-router-dom';
import { Container, Form, FormBtn, FormCover, H3, MediumSpacing } from "../../styles";

export const Login = ({ setToken }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        const user = {
            username: username,
            password: password
        };

        try {
            const { data } = await axios.post('/token/', user, {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });

            localStorage.setItem('access_token', data.access);
            localStorage.setItem('refresh_token', data.refresh);
            localStorage.setItem('username', username);
            axios.defaults.headers.common['Authorization'] = `Bearer ${data.access}`;
            setToken(data.access);
            navigate("/");
            window.location.reload();

        } catch (error) {
            console.error('Login failed:', error);
            // Optionally handle error display to the user here
        }
    };

    return (
        <FormCover>
            <Form onSubmit={submit}>
                <div>
                    <H3>Sign In</H3>
                    <MediumSpacing/>
                    <div>
                        <label>Username</label>
                        <br/>
                        <input
                            placeholder="Enter Username"
                            name="username"
                            type="text"
                            value={username}
                            required
                            onChange={e => setUsername(e.target.value)}
                        />
                    </div>
                    <MediumSpacing/>
                    <div>
                        <label>Password</label>
                        <br/>
                        <input
                            name="password"
                            type="password"
                            placeholder="Enter password"
                            value={password}
                            required
                            onChange={e => setPassword(e.target.value)}
                        />
                    </div>
                    <div>
                        <FormBtn type="submit">Submit</FormBtn>
                    </div>
                </div>
            </Form>
            <span>admin/admin</span><br/>
            <span>olivia-19890614/19890614</span><br/>
            <span>chloe-19950215/19950215</span>
        </FormCover>
    );
};

export default Login;
